import React from "react";
import "./Frame8.css";

function Frame8(props) {
  const { children } = props;

  return (
    <div className="frame-8-9">
      <p className="x5-mise-en-action-des-contre-mesures">{children}</p>
    </div>
  );
}

export default Frame8;
